import useHasExperiment from '../useHasExperiment';
import useLoadedLegacyAPITokens from '../useLoadedLegacyAPITokens';

import { useIsOnParticipateAllowlist } from './useIsOnParticipateAllowlist';

export function useIsLegacyAPITokenManagementEnabled() {
  const legacyAPItokens = useLoadedLegacyAPITokens();
  const isParticipateAllowlisted = useIsOnParticipateAllowlist();
  const isLegacyAPIManagementEnabled = useHasExperiment(
    'nov_2023_legacy_api_management',
    'treatment',
  );
  return (
    isParticipateAllowlisted || isLegacyAPIManagementEnabled || Boolean(legacyAPItokens?.length)
  );
}
